import React from "react";
import { Card, CardBody } from "reactstrap";
import { H3, P, H4 } from "../../../../AbstractElements";
import {
    convertDate,
    formatCurrency2,
} from "../../../../Library/custom_utils";
import TermCardChart from "./TermCardChart";

const TermCard = ({ data }) => {
    // Check if data exists AND has actual content (like a term or amount)
    if (!data || Object.keys(data).length === 0) {
        return (
            <Card className="p-4 text-center" style={{ borderRadius: "15px", border: '1px dashed #ccc' }}>
                <CardBody>
                    <div className="p-3">
                        <H4 attrH4={{ className: "text-muted text-black mb-0" }}>
                            No Term Savings Available
                        </H4>
                    </div>
                </CardBody>
            </Card>
        );
    }

    const fixData = {
        term1: { chart: { color: "#ff000088" } },
        term2: { chart: { color: "var(--theme-deafult)" } },
        term30: { chart: { color: "var(--theme-deafult)" } },
        term90: { chart: { color: "var(--theme-secondary)" } },
        term180: { chart: { color: "var(--theme-secondary)" } },
        term365: { chart: { color: "#445566" } },
    };

    const getDayRemaining = () => {
        const startedDate = new Date(data.createdAt);
        const now = new Date();
        const timeDiff = (now - startedDate) / (1000 * 3600 * 24);
        return Math.max(Math.floor(timeDiff), 0);
    };

    const getHoursRemaning = () => {
        const startedDate = new Date(data.createdAt);
        const now = new Date();
        const timeDiff = (now - startedDate) / (1000 * 60);
        return Math.max(120 - Math.floor(timeDiff), 0);
    };

    const getEndDate = (start, add) => {
        const startedDate = new Date(start);
        startedDate.setDate(startedDate.getDate() + parseInt(add));
        return convertDate(startedDate);
    };

    const unit = data.term === 1 ? "hours" : "days";
    const series =
        data.term === 1
            ? [((120 - getHoursRemaning()) * 100) / 120]
            : [(getDayRemaining() * 100) / data.term];

    return (
        <Card
            className="widget-hover pt-0 pb-0 font-outfit"
            style={{ borderRadius: "15px" }}
        >
            <CardBody className="radial-progress-card">
                <div>
                    <div className="d-flex">
                        <div style={{ flex: 2 }}>
                            <H4 attrH4={{ className: "font20-bold f-light mb-3" }}>
                                {`Term (${data.term === 1 ? 2 : data.term} ${unit}) `}
                            </H4>
                            <H3 attrH3={{ className: `font-secondary font46-bold p-t-15` }}>
                                {formatCurrency2(data.amount, 12)}
                            </H3>
                        </div>
                        <div className="radial-chart-wrap" style={{ flex: 1 }}>
                            <TermCardChart
                                chartHeight={200}
                                series={series}
                                chartOption={fixData[`term${data.term}`]}
                                daysLeft={Math.max(data.term - getDayRemaining(), 0)}
                                hoursLeft={data.term == 1 ? getHoursRemaning() : null}
                            />
                        </div>
                    </div>

                    <div className={"d-flex"} style={{ gap: 10 }}>
                        <div
                            style={{
                                borderRadius: 100,
                                background: "#FFE3DE",
                                padding: "5px 15px",
                            }}
                        >
                            <P attrPara={{ className: "font-danger font14-semibold" }}>
                                Date Started: {convertDate(data.createdAt)}
                            </P>
                        </div>
                        <div
                            style={{
                                borderRadius: 100,
                                background: "#FFE3DE",
                                padding: "5px 15px",
                            }}
                        >
                            <P attrPara={{ className: "font-danger font14-semibold" }}>
                                End Date:{" "}
                                {getEndDate(data.createdAt, data.term == 1 ? 0 : data.term)}
                            </P>
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default TermCard;